/**
 * navigation/appStack.tsx
 * The notification console content as a native-stack. Lateral sidebar
 * navigation, so animation is disabled to match an instant view-swap. The
 * persistent shell (sidebar/topbar) lives in appShell.tsx around this navigator.
 */
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import type { AppStackParamList } from './types';

import LogScreen from '../screens/log';
import HealthScreen from '../screens/health';
import SendTestScreen from '../screens/sendTest';
import QuotasScreen from '../screens/quotas';
import ApiKeysScreen from '../screens/apiKeys';
import TemplatesScreen from '../screens/governance/templates';
import TemplateDetailScreen from '../screens/governance/templateDetail';
import ConsentSuppressionScreen from '../screens/governance/consentSuppression';

const Stack = createNativeStackNavigator<AppStackParamList>();

export default function AppStack() {
  return (
    <Stack.Navigator
      initialRouteName="log"
      screenOptions={{ headerShown: false, animation: 'none' }}
    >
      <Stack.Screen name="log" component={LogScreen} />
      <Stack.Screen name="health" component={HealthScreen} />
      <Stack.Screen name="test" component={SendTestScreen} />
      <Stack.Screen name="quotas" component={QuotasScreen} />
      <Stack.Screen name="apikeys" component={ApiKeysScreen} />
      {/* SKNOTIFICATION-GLOBAL-CR-001 */}
      <Stack.Screen name="templates" component={TemplatesScreen} />
      <Stack.Screen name="templateDetail" component={TemplateDetailScreen} />
      <Stack.Screen name="governance" component={ConsentSuppressionScreen} />
    </Stack.Navigator>
  );
}
